import styled from '@emotion/styled';
import { device, responseFont, typography } from '@landsbankinn/ui';
import React from 'react';
import { SliceWrapper } from './SliceWrapper';

interface IProps {
  quote: string | null;
  author: string | null;
  title: string | null;
  isArticle: boolean;
}
const Wrapper = styled.div``;

const Copy = styled.blockquote`
  font-family: 'LB Centro Slab';
  ${responseFont(26, 34)}
  line-height: ${48 / 34};

  position: relative;
  margin-bottom: 1em;
  padding-left: 30px;

  border-left: 1px solid #000;

  @media ${device.tablet} {
    padding-left: 50px;
  }
  @media ${device.desktop} {
    padding-left: 100px;
  }
`;

const Cite = styled.cite`
  ${typography.bodyEditorial}
  padding-left: 30px;

  @media ${device.tablet} {
    padding-left: 50px;
  }
  @media ${device.desktop} {
    padding-left: 100px;
  }
`;

const Title = styled.p`
  padding-left: 30px;
  @media ${device.tablet} {
    padding-left: 50px;
  }
  @media ${device.desktop} {
    padding-left: 100px;
  }
`;

export const Quote = ({ quote, author, title, isArticle }: IProps) => {
  return (
    <SliceWrapper
      left={
        <Wrapper>
          <Copy>{quote}</Copy>
          {author && <Cite>{author}</Cite>}
          {title && <Title>{title}</Title>}
        </Wrapper>
      }
      isArticle={isArticle}
    />
  );
};
